<template>
  <div>
    <div class="contianer">
      <div class="cardContainer">
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgGreen" />
          </van-col>
          <van-col span="22">
            <div class="border">
              <van-field v-model="orderObj.startAddress" placeholder="请输入上车点" readonly="readonly" />
            </div>
          </van-col>
        </van-row>
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgRed" />
          </van-col>
          <van-col span="22">
            <div class="border">
              <van-field v-model="orderObj.endAddress" placeholder="请输入目的地" readonly="readonly" />
            </div>
          </van-col>
        </van-row>
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgUser" />
          </van-col>
          <van-col span="22">
            <div class="border borderArrow" name="arrow">
              <van-field v-model="orderObj.number" placeholder="请输入乘车人数" readonly="readonly" />
            </div>
          </van-col>
        </van-row>
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgTime" />
          </van-col>
          <van-col span="22">
            <div class="border borderArrow">
              <van-field v-model="orderObj.time" placeholder="请选择用车时间段" readonly="readonly" />
            </div>
          </van-col>
        </van-row>
      </div>
    </div>

    <div class="awaitContainer">
      <p class="awaitTitle">正在为您寻找合适的车辆，请耐心等待…</p>
      <div class="timeElement">{{setIntervalTime}}</div>
    </div>
    <div class="clearContainer">
      <div class="clearButton" @click="cancellationOrderFun">
        <van-icon name="clear" />取消订单
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Notify } from "vant";
//import { apiCancelOrder } from "@/utils/apiFun.js";
import { WaitingOrder } from "@/api/orderReceiving.js";
import { formattingTime } from "@/utils/public.js";
import { cancellationOrder } from "@/api/orderReceiving.js";
export default {
  name: "orderReceiving",
  data() {
    return {
      imgUrl: require("../../assets/home/index-banner.png"),
      imgRed: require("../../assets/home/yuan-red.png"),
      imgGreen: require("../../assets/home/yuan-green.png"),
      imgUser: require("../../assets/home/user.png"),
      imgTime: require("../../assets/home/time.png"),
      imgCar: require("../../assets/home/car1.png"),
      userObj: this.$route.query,
      //等待时长
      setIntervalTime: "",
      minute: 0,
      hour: 0,
      second: 0,
      //定时器
      setInterval: null,
      //判断是返回键还是点击事件
      isClick:false,
      //订单路线信息
      orderObj: {
        startAddress: null,
        startDate: null,
        endAddress: null,
        endDate: null,
        number: null,
        time: null
      }
    };
  },
  created() {
    this.createFun();
  },
  mounted() {
    this.setInterval = this.setIntervalFun();
    // if (window.history && window.history.pushState) {
    //   console.log('兼听返回按钮')
    //   // 往历史记录里面添加一条新的当前页面的url
    //   history.pushState(null, null, document.URL);
    //   // 给 popstate 绑定一个方法 监听页面刷新
    //  window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
    // }
  },
  methods: {
    //定时器
    setIntervalFun() {
      return setInterval(() => {
        ++this.second;
        if (this.second % 5 === 0) {
          this.WaitingOrderFun();
        }
        if (this.second === 60) {
          this.second = 0;
          this.minute++;
        } else if (this.minute === 59) {
          this.minute = 0;
          this.hour++;
        } else if (this.hour === 24) {
          this.second = 0;
          this.minute = 0;
          this.hour = 0;
        }
        if (this.second < 10) {
          this.second = "0" + this.second;
        }
        if (this.minute < 10 && this.hour === 0) {
          this.setIntervalTime = `0${this.minute}:${this.second}`;
        } else if (this.minute >= 10 && this.hour === 0) {
          this.setIntervalTime = `${this.minute}:${this.second}`;
        } else if (this.hour !== 0 && this.minute < 10) {
          this.setIntervalTime = `${this.hour}:0${this.minute}:${this.second}`;
        } else if (this.hour !== 0 && this.minute >= 10) {
          this.setIntervalTime = `${this.hour}:${this.minute}:${this.second}`;
        }
      }, 1000);
    },
    clearFun() {
      clearInterval(this.setInterval);
    },
    cancellationOrderFun(){
      var _that = this;
       Dialog.confirm({
        title: "提示",
        message: "是否取消订单"
      }).then(()=> {
        console.log('取消订单')
        cancellationOrder().then(res => {    
          let result = res.data;
          switch (result.code) {
            case "0": //取消订单成功
              Notify(result.msg);
              _that.$router.go(-1)           
              break;
            case "0000": //没有登录
            _that.$router.go(-1)
              break;
            default:
            //  this.$router.replace({ path: '/' });
          }
        });
      })
    },
    //监听手机返回物理键
    backChange() {
      var _that = this;
      //  Dialog.confirm({
      //   title: "提示",
      //   message: "是否取消订单"
      // }).then(()=> {
        cancellationOrder().then(res => {
          let result = res.data;
          console.log('code',result.code)
          switch (result.code) {
            case "0": //取消订单成功
              Notify(result.msg);
              _that.$router.go(-1)           
              break;
            case "0000": //没有登录
            _that.$router.go(-1)
              break;
            default:
            //  this.$router.replace({ path: '/' });
          }
        });
    // })
    },
    //等待接单
    WaitingOrderFun() {
      WaitingOrder().then(res => {
        console.log("接单", res);
        let result = res.data.data;
        if (res.data.code !== "0") {
          //接口失败
          this.$router.push({ path: "/" });
        }
        if (result.status === 1 || result.status > 1) {
          this.$router.push({ path: "/driver/orderReceiving" });
        }
      });
    },
    //初始化input接口
    createFun() {
      WaitingOrder().then(res => {
        console.log(res);
        let result = res.data.data;
        this.orderObj.startAddress = result.startAddress;
        this.orderObj.startDate = result.startDate;
        this.orderObj.endDate = result.endDate;
        this.orderObj.endAddress = result.endAddress;
        this.orderObj.number = result.number + "人";

        let stateTime = result.startDate;
        let endTime = result.endDate;
        let endHour = endTime.split(" ");
        let stateHour = stateTime.split(" ");
        let GMT = new Date(stateTime);
        let time = formattingTime("day:MM:dd", GMT);
        let timeObj = time.dataText + " " + stateHour[1] + "-" + endHour[1];
        this.orderObj.time = timeObj;
      });
    }
  },
  //页面销毁前钩子函数
  beforeDestroy(){
   
  },
  //页面销毁钩子函数
  destroyed() {
    //消除定时器
    this.clearFun(this.setInterval);
    //  window.removeEventListener("popstate", function(){}, false);
    // window.addEventListener("popstate", this.backChange, false);
    
  }
};
</script>
<style lang="scss" scoped>
$gray6: #666666;
$bluck3: #333333;
.contianer {
  padding-left: 24px;
  padding-right: 24px;
  margin-top: 28px;
}
.awaitContainer {
  margin-top: 50px;
  color: $gray6;
  text-align: center;
  .awaitTitle {
    font-size: 28px;
  }
  .timeElement {
    margin-top: 60px;
    height: 90px;
    font-size: 78px;
    font-weight: 500;
    color: $bluck3;
  }
}
.clearContainer {
  position: fixed;
  bottom: 40px;
  left: 24px;
  right: 24px;
  text-align: center;
  .clearButton {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 38px;
    width: 100%;
    height: 120px;
    border-radius: 16px;
    letter-spacing: 1px;
    box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.12);
    color: $gray6;
    cursor: pointer;
    &:active {
      background: rgba($color: #000000, $alpha: 0.1);
    }
  }
}
</style>